export const generateId = () => {
  let result = '';
  for (let j = 0; j < 8; j += 1) {
    if (j === 8 || j === 12 || j === 16 || j === 20) result += '-';
    const i = Math.floor(Math.random() * 16)
      .toString(16)
      .toUpperCase();
    result += i;
  }
  return result;
};

export const uuid = generateId;

const canvasHandler = { uuid, generateId };

export default canvasHandler;
